import type { FieldCodec } from 'v5/core/entity-values/values.types';
import { customFieldColumns } from './customFieldColumns';
import { findCustomFieldRowForRead } from './customFieldRows';
import { validateField, validation } from './validation';

function isEmpty(value: string[]): boolean {
  return value.length === 0;
}

function toOptionIds(value: string[]): number[] {
  return value.map(id => Number(id));
}

/** MULTI_SELECT custom field; form values are option ids as strings. */
export const multiSelectCodec: FieldCodec<'multi-select'> = {
  decode(entity, spec, ctx) {
    const row = findCustomFieldRowForRead(entity, spec.definition.id, ctx);
    return (row?.multi_select_ids ?? []).map(id => String(id));
  },
  encode(value) {
    return {
      type: 'custom',
      columns: customFieldColumns({ multi_select_ids: toOptionIds(value) })
    };
  },
  empty() {
    return [];
  },
  isEmpty,
  validate(value, spec) {
    return validateField(value, spec, isEmpty, value =>
      toOptionIds(value).some(id => !Number.isInteger(id))
        ? validation.invalid({ code: 'invalid-option' })
        : validation.valid()
    );
  }
};
